import { Box, useTheme } from '@mui/material';

interface LogoBoxProps {
  logo: string;
  alt?: string;
}

export const LogoBox = ({ logo, alt = '' }: LogoBoxProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.common.white,
        padding: '2px',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `1px solid ${theme.palette.divider}`,
        width: '32px',
        height: '32px',
      }}
    >
      <img
        src={logo}
        alt={alt}
        style={{
          width: '24px',
          height: '24px',
          borderRadius: '4px',
          display: 'block',
        }}
      />
    </Box>
  );
};
